var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodebox3 = function SvgCodebox3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#F6F6F6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.5 6.917 34.583 22.479v24.208l-17.291 11.24L42.5 76.084l-17.292-11.24-17.291-11.24V29.396L42.5 6.916Z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 7 8 29l34 24 34.5-24L42 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.365 7 24 18.478 42.365 31 61 18.478 42.365 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 19v44M42 75V31M59 65V20",
    strokeLinecap: "round"
  }))));
};
export default SvgCodebox3;